import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import LaunchableConfigurationView from "./LaunchableConfigurationView";
import { GPUInstanceType } from "components/Environment/Settings/Tabs/Compute/InstanceChanger/GPUTypes";
import { parsePortMappingEntry } from "components/Environment/utils";
import agent from "server";
import { shortenFileName } from "../../utils";
import { ContainerSelected } from "components/Environment/shared/BuildTypes";
import { CreateFirewallRule } from "components/Environment/Create/ExposePorts";

interface LaunchableConfigurationViewFromParamsProps {
  intendedInstanceType: string | null;
  intendedDiskStorage: string | null;
  instanceTypeObject: GPUInstanceType | null;
  instanceLoading: boolean;
  workspaceGroupId: string | null;
  containerSelected: ContainerSelected | null;
  forceJupyterInstall: boolean | null;
  cuda: string | null;
  python: string | null;
  diskStorage: string | null;
  file: string | null;
  ports: Record<string, string> | null;
  firewallRules: CreateFirewallRule[] | null;
  disabled?: boolean;
  onSetNewCurrentInstanceType?: (
    instanceTypeObject: GPUInstanceType | null,
    diskStorage: string
  ) => void;
  lifecycleScript?: string | null;
}

const LaunchableConfigurationViewFromParams: React.FC<
  LaunchableConfigurationViewFromParamsProps
> = ({
  intendedInstanceType,
  intendedDiskStorage,
  instanceTypeObject,
  instanceLoading,
  workspaceGroupId,
  containerSelected,
  forceJupyterInstall,
  cuda,
  python,
  diskStorage,
  file,
  ports,
  firewallRules,
  disabled,
  onSetNewCurrentInstanceType,
  lifecycleScript,
}) => {
  const history = useHistory();
  const [shortFileName, setShortFileName] = useState("");

  useEffect(() => {
    async function updateShortFileName() {
      if (file) {
        const shortName = await shortenFileName(file || "");
        setShortFileName(shortName);
      } else {
        setShortFileName("");
      }
    }
    updateShortFileName();
  }, [file]);

  return (
    <LaunchableConfigurationView
      intendedInstanceType={intendedInstanceType}
      intendedDiskStorage={intendedDiskStorage}
      loadingInstance={instanceLoading}
      instanceTypeObject={instanceTypeObject}
      diskStorage={diskStorage}
      file={file}
      shortFileName={shortFileName}
      python={python}
      cuda={cuda}
      containerSelected={containerSelected}
      forceJupyterInstall={forceJupyterInstall}
      ports={ports}
      firewallRules={firewallRules}
      disabled={disabled}
      onSetNewCurrentInstanceType={onSetNewCurrentInstanceType}
      lifecycleScript={lifecycleScript}
    />
  );
};

export default LaunchableConfigurationViewFromParams;
